import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-28/task-01";

const task: Slide = {
  titleHtml: `Calculate the tension T of a 0.3 mm diameter violin string made of iron
  <br>(ρ = 7 874 kg/m<sup>3</sup>) so that it plays the same note as a flute of same length.
  <br>Consider a cylindrical bar made of rubber (ρ = 950 kg/m<sup>3</sup>, E = 2.5 GPa).
  <br>Calculate the speed v of compression waves.`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
